import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed } from 'vue'
import { useTaskProfiles } from '../../store/useTaskProfiles'
import FormBulkUpdateRai from './FormBulkUpdateRai.vue'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { useTimers } from '../../store/timers'

export default /*#__PURE__*/_defineComponent({
  __name: 'BulkUpdateRai',
  props: {
    tasks: {}
  },
  emits: ["setBulkRaiFilter", "bulkDataChange"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`form.${key}`)
const { updateRAI, triggerTaskDataRef } = useTaskProfiles()
const { getActiveChildTimer } = storeToRefs(useTimers())
const bulkUpdateRai = ref(false)
const taskIds = computed(() => (props.tasks ? props.tasks.map((task: any) => task.task_id) : []))
const updateRaiCodes = async (
  data: { rai_code: any; rai_reason_code: any },
  tasksToUpdate: any[]
) => {
  if (tasksToUpdate.length > 0) {
    //compare against now, but strip out time
    const today = new Date()
    today.setUTCHours(0, 0, 0, 0)
    for (const task of tasksToUpdate) {
      const taskStartDate = new Date(task.task_start_date)
      taskStartDate.setUTCHours(0, 0, 0, 0)
      if (
        today.getTime() >= taskStartDate.getTime() &&
        String(getActiveChildTimer.value?.data.task_id) !== String(task.task_id) // Don't bulk update the task if it's currently in-progress
      ) {
        //update rai code, let task profile store handle undefined reason code
        await updateRAI(
          task.task_id as string,
          data.rai_code.code,
          data.rai_reason_code?.code,
          true
        )
      }
    }
    //trigger ref update and save data
    await triggerTaskDataRef()
  }

  //tell parent component
  emit('bulkDataChange')
}
const setBulkRaiFilter = () => {
  emit('setBulkRaiFilter')
  bulkUpdateRai.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_btn, {
      color: "secondary",
      label: label('updateStatus'),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (bulkUpdateRai.value = true))
    }, null, 8, ["label"]),
    _createVNode(FormBulkUpdateRai, {
      modelValue: bulkUpdateRai.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((bulkUpdateRai).value = $event)),
      "checked-task-ids": taskIds.value,
      onUpdateRaiCode: _cache[2] || (_cache[2] = ($event: any) => (updateRaiCodes($event, _ctx.tasks))),
      onSetBulkRaiFilter: setBulkRaiFilter
    }, null, 8, ["modelValue", "checked-task-ids"])
  ], 64))
}
}

})